import { createSelector } from "@ngrx/store";
import { AppState } from "../reducers";

const instructionFeature = (state: AppState) => state.instruction;

export const instructions = createSelector(instructionFeature, (state) => ({
  confirmedInstructions: state.confirmedInstructions,
  openInstructions: state.openInstructions,
  isLoading: state.isLoading,
}));
